class DataLayerService {
  private dataLayer: Record<string, any> = {};

  getDataLayer() {
    return this.dataLayer;
  }

  updateDataLayer(newData: Record<string, any>) {
    this.dataLayer = { ...this.dataLayer, ...newData };
  }

  clearDataLayer() {
    this.dataLayer = {};
  }
}

export const dataLayerService = new DataLayerService();
